import { singleton } from 'tsyringe'

@singleton()
export default class Base64Service {
  toBase64(str: string) {
    return Buffer.from(str).toString('base64')
  }
}
